import { Component, Inject } from '@angular/core';
import {  MAT_DIALOG_DATA } from '@angular/material';

import { EnvSettingDialogData } from './environment-setting-dialog.data';

@Component({
    selector : 'env-setting-dialog',
    template: require('./environment-setting-dialog.component.html'),
    styles: [require('./environment-setting-dialog.component.scss')]
})
export class EnvSettingDialog {
    constructor( @Inject(MAT_DIALOG_DATA) public data: EnvSettingDialogData) {
        data.baselineType = "No Baseline";
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/dialogs/environment-setting-dialog/environment-setting-dialog.component.ts